import React, { lazy, useEffect } from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./page/Home";
import Brand from "./page/Brands";
import Category from "./page/Categories";
import ProductsDetail from "./page/Product";
import Products from "./page/Products";
import OrderResume from "./page/OrderResume";
import OrderResumePag from "./page/OrderResumePag";
import OrderResumeStatus from "./page/OrderResumeStatus";
import RechargeTV from "./page/RechargeTV";
import RechargeCell from "./page/RechargeCell";
import TicketSearch from "./page/TicketSearch";
import SearchResultTravel from "./page/SearchResultTravel";
import FlightDetails from "./page/FlightDetails";
import PointsTransfer from "./page/PointsTransfer";
import OrderPlaced from "./page/OrderPlaced";
import OrderNotApproved from "./page/OrderNotApproved";
import OrderPlacedSuccessfully from "./page/OrderPlacedSuccessfully";
import Investir from "./page/Investir";
import AuthRedirectComponent from "./page/Authenticate/auth";
import MyAccount from "./page/MyAccount";
import MyAccountPj from "./page/MyAccountPJ";
import MyRequests from "./page/MyRequests";
import HelpYou from "./page/HelpYou";
import RedemptionReceivedAndApproved from "./page/RedemptionReceivedAndApproved";
import RechargeSummary from "./page/RechargeSummary";
import TransferSummary from "./page/TransferSummary";
import Favorites from "./page/Favorites";
const LazyErrors = lazy(() => import(`./page/Errors`));
import ProductVariation from "./page/ProductVariation";
import Policy from "./page/Policy";
import Exchange from "./page/Exchange";
import ErrorPage from "./page/ErrorPage";
import NotFound from "./page/ErrorPage/notFound";

import Brands from "./components/OpenCategoryOrBrand/SeeAllBrands";
import Categories from "./components/OpenCategoryOrBrand/SeeAllCategory";

import { TravelSearch } from "./page/TravelSearch";
import { HotelsSearchResult } from "./page/HotelsSearchResult";
import { Hotel } from "./page/Hotel";
import { HotelTravellers } from "./page/HotelTravellers";
import { CarSearchResult } from "./page/CarSearchResult";
import { CarConductor } from "./page/CarConductor";
import { CheckoutTravel } from "./page/CheckoutTravel";
import { CheckoutTravelMessage } from "./page/CheckoutTravelMessage";
import ListAddressesPage from "page/ListAddresses";

import SessionExpired from "page/SessionExpired";

import { useSelector } from "react-redux";
import { getTokenExpired } from "./Redux/authSlice";
import FlightTickets from "page/FlightTickets/FlightTickets";
import Hotels from "page/Hotels/Hotels";
import ResumoHotel from "page/ResumoHotel";
import FlightResume from "page/FlightResume";
import { getCookie, getJwtExpirationDate } from "./lib/cookies";

export default function ConnectionBetweenPages() {
  const isTokenExpired = useSelector(getTokenExpired);

  useEffect(() => {
    const checkTokenExpiration = () => {
      const currentToken = getCookie("wlt");
      const currentPath = window.location.pathname;
      
      if (!currentToken || currentPath.includes('/loja/auth')) {
        return;
      }

      try {
        const expirationDate = getJwtExpirationDate(currentToken)?.getTime();
        if (!expirationDate) return;
        
        const now = Date.now();
        const timeUntilExpiration = expirationDate - now;
        
        if (timeUntilExpiration > 0 && timeUntilExpiration <= 300000) {
          const fullPath = currentPath + window.location.search;
          window.location.href = `/loja/auth?token=${encodeURIComponent(currentToken)}&redirect=${encodeURIComponent(fullPath)}`;
          return;
        }
      } catch (error) {
        console.error('Erro ao verificar expiração do token:', error);
      }
    };

    checkTokenExpiration();

    const expirationInterval = setInterval(() => {
      checkTokenExpiration();
    }, 30 * 1000);

    return () => {
      clearInterval(expirationInterval);
    };
  }, []);

  return isTokenExpired ? (
    <SessionExpired />
  ) : (
    <Routes>
      <Route path="/" element={<Navigate to="/loja" />} />
      <Route path="loja/auth" element={<AuthRedirectComponent />} />
      <Route path="loja/Investir/" element={<Investir />} />
      <Route path="loja/" element={<Home />} />
      <Route path="loja/brands/:id" element={<Brand />} />
      <Route path="loja/brands/" element={<Brands />} />
      <Route path="loja/category/:id" element={<Category />} />
      <Route path="loja/categories/" element={<Categories />} />
      <Route path="loja/product/:id" element={<ProductsDetail />} />
      <Route path="loja/products/:desc" element={<Products />} />
      <Route path="loja/orderresume/" element={<OrderResume />} />
      <Route path="loja/list-addresses/" element={<ListAddressesPage />} />
      <Route path="loja/orderresumepag/" element={<OrderResumePag />} />
      <Route
        path="loja/orderresumestatus/:id"
        element={<OrderResumeStatus />}
      />
      <Route path="loja/passagens-aereas" element={<FlightTickets />} />
      <Route path="loja/passagens-aereas/voos" element={<FlightResume />} />
      <Route path="loja/recharge-tv/" element={<RechargeTV />} />
      <Route path="loja/recharge-cell/" element={<RechargeCell />} />
      <Route path="loja/searchresulttravel/" element={<SearchResultTravel />} />
      <Route path="loja/flightdetails/" element={<FlightDetails />} />
      <Route path="loja/points-transfer/" element={<PointsTransfer />} />
      <Route path="loja/orderplaced/" element={<OrderPlaced />} />
      <Route path="loja/ordernotapproved/" element={<OrderNotApproved />} />
      <Route
        path="loja/orderplacedsuccessfully/"
        element={<OrderPlacedSuccessfully />}
      />
      <Route path="loja/myaccount/" element={<MyAccount />} />
      <Route path="loja/pj/myaccount/" element={<MyAccountPj />} />
      <Route path="loja/myrequests/" element={<MyRequests />} />
      <Route path="loja/myrequests/help/:uuid" element={<HelpYou />} />
      <Route
        path="loja/redemptionreceivedandapproved/"
        element={<RedemptionReceivedAndApproved />}
      />
      <Route path="loja/rechargesummary/" element={<RechargeSummary />} />
      <Route path="loja/transfersummary/" element={<TransferSummary />} />
      <Route path="loja/favorites/" element={<Favorites />} />
      <Route path="loja/productvariation/" element={<ProductVariation />} />
      <Route path="loja/policy/" element={<Policy />} />
      <Route path="loja/exchange/" element={<Exchange />} />
      <Route path="loja/error/" element={<ErrorPage />} />
      <Route path="loja/search-travel" element={<TravelSearch />} />
      <Route
        path="loja/search-hotels-result"
        element={<HotelsSearchResult />}
      />
      <Route path="loja/hoteis" element={<Hotels />} />
      <Route path="loja/resumo-hotel/:uuid" element={<ResumoHotel />} />
      <Route path="loja/hotel" element={<Hotel />} />
      <Route path="loja/hotel-travellers" element={<HotelTravellers />} />
      <Route path="loja/search-cars-result" element={<CarSearchResult />} />
      <Route path="loja/car-conductor" element={<CarConductor />} />
      <Route
        path="loja/checkout-travel/:product"
        element={<CheckoutTravel />}
      />
      <Route
        path="loja/checkout-message-travel/:id"
        element={<CheckoutTravelMessage />}
      />
      <Route
        path="loja/checkout-message-travel"
        element={<CheckoutTravelMessage />}
      />
      <Route path="loja/notFound/" element={<NotFound />} />
      <Route path="*" element={<LazyErrors />} />
    </Routes>
  );
}
